var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarClothes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2185 3.09982H20.7807C20.9067 3.09708 21.0351 3.12086 21.1577 3.17411L25.3297 4.96214C25.4462 5.00795 25.5548 5.07886 25.6471 5.17456L28.636 8.16343C28.8048 8.33221 28.8996 8.56113 28.8996 8.79982V23.7998C28.8996 24.2969 28.4967 24.6998 27.9996 24.6998H24.6996V27.9998C24.6996 28.4969 24.2967 28.8998 23.7996 28.8998H16.0184L15.9996 28.9L15.9808 28.8998H8.19961C7.70255 28.8998 7.29961 28.4969 7.29961 27.9998V24.6998H3.99961C3.50255 24.6998 3.09961 24.2969 3.09961 23.7998V8.79982C3.09961 8.56113 3.19443 8.33221 3.36321 8.16343L6.35206 5.17458C6.44439 5.07886 6.55302 5.00795 6.66948 4.96213L10.8387 3.17531C10.9622 3.12122 11.0915 3.09706 11.2185 3.09982ZM10.7553 5.16942L8.62268 6.08339L13.1925 10.3486L10.7553 5.16942ZM19.3814 4.89982L15.9996 12.0862L12.6178 4.89982H19.3814ZM23.3765 6.08339L21.2439 5.1694L18.8066 10.3487L23.3765 6.08339ZM16.8996 14.5907L24.9779 7.05095L27.0996 9.17261V22.8998H24.6996V12.9998C24.6996 12.5028 24.2967 12.0998 23.7996 12.0998C23.3026 12.0998 22.8996 12.5028 22.8996 12.9998V27.0998H16.8996V14.5907ZM4.89961 9.17261L7.02128 7.05095L15.0996 14.5907V27.0998H9.09961V12.9998C9.09961 12.5028 8.69667 12.0998 8.19961 12.0998C7.70255 12.0998 7.29961 12.5028 7.29961 12.9998V22.8998H4.89961V9.17261Z",
    fill: "url(#paint0_linear_3591_14783)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3591_14783",
    x1: 3.09961,
    y1: 31.6643,
    x2: 31.8737,
    y2: 25.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarClothes);
export default __webpack_public_path__ + "static/media/avatar-clothes.00ee4d67c5f8b3a906e240920b0305b1.svg";
export { ForwardRef as ReactComponent };